<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
    <defs>
        <path id="prefix__a" d="M7 10.267L3.081 12.393 3.893 8.009 0.66 4.94 5.08 4.357 7 0.333 8.92 4.357 13.34 4.94 10.107 8.009 10.919 12.393z"/>
    </defs>
    <g fill="none" fill-rule="evenodd" transform="translate(3 3)">
        <mask id="prefix__b" fill="#fff">
            <use xlink:href="#prefix__a"/>
        </mask>
        <path stroke="#979797" d="M7 1.494L5.414 4.817l-3.65.482 2.67 2.535-.67 3.62L7 9.698l3.236 1.756-.67-3.62 2.67-2.535-3.65-.482L7 1.494z"/>
        <path fill="#FC4E36" d="M-0.5 -0.5H14.5V14.5H-0.5z" mask="url(#prefix__b)"/>
    </g>
</svg>
